<template>
  <div>
    <button class="button full-100 is-primary" @click="handlePlayOnWeb()">
      {{ $t('playGameBtn') }}
    </button>
  </div>
</template>

<script>
// import axios from 'axios'

export default {
  name: 'LoginSlotOther',
  props: {
    url: {
      type: String
    },
    trigger: {
      type: Number
    }
  },
  watch: {
    trigger: {
      // immediate: true,
      async handler() {
        this.handlePlayOnWeb()
      }
    }
  },
  methods: {
    handlePlayOnWeb() {
      const a = document.createElement('a')
      a.setAttribute('href', this.url)
      a.setAttribute('target', '_blank')
      a.click()
      document.body.appendChild(a)
    }
  }
}
</script>

<style scoped lang="scss">
.height-0 {
  height: 0px !important;
  visibility: hidden;
}
</style>
